import { ColumnPreset } from 'models/column_preset'
import { toast } from 'react-toastify'
import { useUpdateColumnPreset } from 'services/columnPresets'
import {
  ColumnPresetFormData,
  ColumnPresetModal,
} from 'components/Filters/saved-filters/ColumnPresetModal'

interface EditColumnPresetModalProps {
  show: boolean
  handleClose: () => void
  columnPreset: ColumnPreset | null
  onPresetUpdated?: () => void
}

export function EditColumnPresetModal({
  show,
  handleClose,
  columnPreset,
  onPresetUpdated,
}: EditColumnPresetModalProps) {
  const updateColumnPreset = useUpdateColumnPreset()

  const handleSubmitSuccess = () => {
    toast.success('Column preset updated!')
    onPresetUpdated?.()
  }

  const updatePreset = async (values: ColumnPresetFormData) => {
    if (!columnPreset) return

    await updateColumnPreset.mutateAsync({
      id: columnPreset.id,
      data: { name: values.name, shared: values.shared },
    })
  }

  return (
    <ColumnPresetModal
      show={show}
      handleClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      confirmButtonText="Update"
      submitApiAction={updatePreset}
      columnPresetToEdit={columnPreset}
      title="Edit Column Preset"
      description="Update the preset name and sharing settings."
    />
  )
}
